export default "__VITE_ASSET__CtL8gAqv__"